import { generateSlug } from 'services/API/helpers'

const options = {
  // weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}

const getMonth = (monthStr, locale)  => {
  return new Date(monthStr + '-1-01').toLocaleDateString(locale, { month: 'long' })
}
const PAGE_SIZE = 3

const defaultQueryParams = {
  populate: 'deep',
  'sort[1]': 'date:desc'
}
export const normalizedContentData = (data) => {
  if (!data) return []
  return data.reduce((acc, curr) => {
    const {
      excerpt,
      year,
      month,
      locale: itemLocale,
      date,
      ...rest
    } = curr.attributes


    const itemsFilters = [
      {
        id: year,
        label: year,
        type: 'year'
      },
      {
        id: month,
        label: getMonth(month, itemLocale),
        type: 'month'
      }
    ]

    const link = {
      href: generateSlug(curr.attributes).join('/'),
      target: '_self',
      locale: itemLocale,
    }

    const dateFormatted = new Date(date)
    const dateString = dateFormatted.toLocaleDateString(itemLocale, options)

    const item = {
      ...rest,
      link,
      locale: itemLocale,
      description: excerpt,
      filters: itemsFilters,
      date: dateString
    }

    acc.push(item)

    return acc
  }, [])
}

const NewsItemsArchive = async (data, locale) => {
  const {
    showFilters,
    filters,
    pageSize,
  } = data

  const itemsSize = !!pageSize ? pageSize : PAGE_SIZE

  const params =  {
    locale,
    'pagination[page]': 1,
    'pagination[pageSize]': itemsSize,
    ...defaultQueryParams
  }

  let header = null


  if (showFilters && filters) {
    header = Object.keys(filters).map(key => {
      const customLabel = data[`${key}FilterLabel`]
      const {
        label,
        items,
      } = filters[key]

      return {
        id: key,
        title: customLabel || label,
        items: items.map(({
          id,
          name,
          ...rest
        }) => {
          return {
            id,
            title: key === 'month' ? getMonth(name, locale) : name,
            ...rest
          }
        })
      }
    })
  }


  const normalizedData = {
    ...data,
    params,
    filters: {
      header,
      content: null
    },
  }

  return normalizedData
}

export default NewsItemsArchive
